const houseRulesInit = {
    events : false,
    pets : false,
    kids : false,
    smoking : false,
    disabilities : false
}

export const convertSuitableListToHouseRules=(suitables, amenities)=>{
    var hr = JSON.parse(JSON.stringify(houseRulesInit))
    if(!suitables || !Array.isArray ( suitables ) || suitables.length == 0) return houseRulesInit

    suitables.forEach(element => {
        if(element == "pets") hr.pets=true
        if(element == "smoking") hr.smoking=true
        if(element == "familyFND") hr.kids=true
        if(element == "events") hr.events=true
    });
    if(amenities && amenities.indexOf("disabiltyFriendly") != -1) hr.disabilities=true
    return hr
}



// WEBPACK FOOTER //
// ./src/platform/utils/property/propertyUtil.js